import React from "react";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { Route, RouteProps } from "react-router-dom";
import { AuthenticationLoading } from "./AuthenticationLoading";
import { AuthenticationError } from "./AuthenticationError";
import { GuestAccountBlock } from "./GuestAccountBlock";
import { loginRequest } from "./config";

interface ProtectedRouteProps extends RouteProps {
  action: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  action,
  ...rest
}) => {
  return (
    <>
      <Route
        {...rest}
        render={() => (
          <MsalAuthenticationTemplate
            authenticationRequest={{
              ...loginRequest,
            }}
            interactionType={InteractionType.Redirect}
            loadingComponent={AuthenticationLoading}
            errorComponent={AuthenticationError}
          >
            <GuestAccountBlock>{children}</GuestAccountBlock>
          </MsalAuthenticationTemplate>
        )}
      />
    </>
  );
};
